import type { SVGProps } from "react";

export const MFAOTPIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14px"
    height="18px"
    viewBox="0 0 14 18"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#757575"
      d="M2.5,7 L2.5,5 C2.5,2.51471863 4.51471863,0.5 7,0.5 C9.48528137,0.5 11.5,2.51471863 11.5,5 L11.5,7 L12,7 C13.1045695,7 14,7.8954305 14,9 L14,16 C14,17.1045695 13.1045695,18 12,18 L2,18 C0.8954305,18 0,17.1045695 0,16 L0,9 C0,7.8954305 0.8954305,7 2,7 L2.5,7 Z M3.5,7 L10.5,7 L10.5,5 C10.5,3.06700338 8.93299662,1.5 7,1.5 C5.06700338,1.5 3.5,3.06700338 3.5,5 L3.5,7 Z M2,8 C1.44771525,8 1,8.44771525 1,9 L1,16 C1,16.5522847 1.44771525,17 2,17 L12,17 C12.5522847,17 13,16.5522847 13,16 L13,9 C13,8.44771525 12.5522847,8 12,8 L2,8 Z M6.5,11 C6.5,10.7238576 6.72385763,10.5 7,10.5 C7.27614237,10.5 7.5,10.7238576 7.5,11 L7.5,14 C7.5,14.2761424 7.27614237,14.5 7,14.5 C6.72385763,14.5 6.5,14.2761424 6.5,14 L6.5,11 Z"
    />
  </svg>
);
